/**
 * Fail-closed B2B enforcement for cart and add-to-cart flows.
 * Unauthorized cart lines are removed on load and after cart mutations.
 */
(() => {
  const purgeEl = document.getElementById('b2b-cart-purge-data');
  if (!purgeEl) return;

  let unauthorizedLineKeys = [];
  try {
    unauthorizedLineKeys = JSON.parse(purgeEl.textContent || '[]');
  } catch (e) {
    unauthorizedLineKeys = [];
  }

  const strings = window.theme?.strings?.b2b || {};

  async function purgeUnauthorizedLines() {
    if (!unauthorizedLineKeys.length || !window.theme?.routes?.cartChange) return;

    for (const lineKey of unauthorizedLineKeys) {
      try {
        await fetch(window.theme.routes.cartChange, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        });
      } catch (e) {
        // Continue purging remaining lines.
      }
    }

    unauthorizedLineKeys = [];
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    document.dispatchEvent(new CustomEvent('on:cart:change'));
  }

  function blockB2bForms() {
    document.querySelectorAll('form.js-product-form[data-b2b-blocked="true"]').forEach((form) => {
      form.addEventListener('submit', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        const msg = strings.cartBlocked || 'This product is not available for your account.';
        const productForm = form.closest('product-form');
        if (productForm?.setErrorMsgState) {
          productForm.setErrorMsgState(msg);
        } else {
          window.alert(msg);
        }
      }, true);
    });
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

    if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
      setTimeout(purgeUnauthorizedLines, 0);
    }

    return response;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      purgeUnauthorizedLines();
      blockB2bForms();
    });
  } else {
    purgeUnauthorizedLines();
    blockB2bForms();
  }
})();
